import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable, throwError } from 'rxjs';
import { HttpRequestPayload } from '@core/models';
import { AuthService } from 'src/app/fpx/core/services/auth/auth.service';
import { HttpRequest } from '../../models/http-provider.model';

@Injectable({
  providedIn: 'root',
})
export class HttpProviderService {
  baseURL: string = '';
  defaultPublisher = '/olive/publisher';
  fileUploadURL: string = '';
  keycloakURL: string = '';
  realm: string = '';
  client: string = '';
  restURL: string = '';
  idleTimeout: number = 0;
  idleTimer: any;
  idleTimeCount: number = 0;
  promptIdleTimeoutB4: number = 30; //in second
  isPromptTimerAlert: boolean = false;
  defaultIdleTimeout: number = 5;

  constructor(
    private httpClient: HttpClient,
    private _authService: AuthService
  ) {
    // this._getConfig();
  }

  invokeApi(request: HttpRequestPayload): Observable<any> {
    let requestURL = this.baseURL;
    requestURL += request.serverContext
      ? request.serverContext
      : this.defaultPublisher;

    requestURL += request.resource;

    /** append the query params */
    if (request.queryParams) {
      requestURL += '?';
      for (let key in request.queryParams) {
        let value = request.queryParams[key];
        if (value) {
          requestURL += `${value.key}=${value.value}&`;
        }
      }
      requestURL = requestURL.substring(0, requestURL.length - 1);
    }
    /** append the filter criteria */
    if (request.filterCriteria) {
      requestURL += request.queryParams ? '&' : '?';
      requestURL += `criteriaDetails=${JSON.stringify(request.filterCriteria)}`;
    }

    let headers: any = {
      'Content-Type': 'application/json',
      authorization: this.authToken,
    };

    /** append the header params  */
    if (request.headerParams) {
      request.headerParams.map((param: any) => {
        headers[param.key] = param.value;
      });
    }

    let httpOpts: { headers: HttpHeaders; observe: any } = {
      headers: new HttpHeaders(headers),
      observe: 'response',
    };
    requestURL = encodeURI(requestURL);

    try {
      switch (request.method) {
        case 'POST':
          return this.httpClient.post(requestURL, request.body, httpOpts);
        case 'GET':
          return this.httpClient.get(requestURL, httpOpts);
        case 'PUT':
          return this.httpClient.put(requestURL, request.body, httpOpts);
        case 'DELETE':
          return this.httpClient.delete(requestURL, httpOpts);
        default:
          return throwError('METHOD NOT DEFINED');
      }
    } catch (error) {
      return throwError(error);
    }
  }

  invokeRestApi(httpRequest: HttpRequest): Observable<any> {

    httpRequest.addHeaderParamter('languageCode','en_US');
    httpRequest.addHeaderParamter('languageId','en_US');
    let request = httpRequest.httpPayload;
    let requestURL = this.baseURL;
    requestURL += request.serverContext
      ? request.serverContext
      : this.defaultPublisher;

    requestURL += request.resource;

    if (request.pathParams && request.pathParams.length > 0) {
      for (let index = 0; index < request.pathParams.length; index++) {
        requestURL = requestURL.replace(`{${request.pathParams[index].key}}`,request.pathParams[index].value);
      }
    }

    /** append the query params */
    if (request.queryParams && request.queryParams.length > 0) {
      requestURL += '?';
      for (let key in request.queryParams) {
        let value = request.queryParams[key];
        if (value) {
          requestURL += `${value.key}=${value.value}&`;
        }
      }
      requestURL = requestURL.substring(0, requestURL.length - 1);
    }
    /** append the filter criteria */
    if (request.filterCriteria) {
      requestURL += request.queryParams && request.queryParams?.length > 0 ? '&' : '?';
      requestURL += `criteriaDetails=${JSON.stringify(request.filterCriteria)}`;
    }

    let headers: any = {
      'Content-Type': 'application/json',
      authorization: this.authToken,
    };

    /** append the header params  */
    if (request.headerParams) {
      request.headerParams.map((param: any) => {
        headers[param.key] = param.value;
      });
    }

    let httpOpts: { headers: HttpHeaders; observe: any } = {
      headers: new HttpHeaders(headers),
      observe: 'response',
    };
    requestURL = encodeURI(requestURL);

    try {
      switch (request.method) {
        case 'POST':
          return this.httpClient.post(requestURL, request.body, httpOpts);
        case 'GET':
          return this.httpClient.get(requestURL, httpOpts);
        case 'PUT':
          return this.httpClient.put(requestURL, request.body, httpOpts);
        case 'DELETE':
          return this.httpClient.delete(requestURL, httpOpts);
        default:
          return throwError('METHOD NOT DEFINED');
      }
    } catch (error) {
      return throwError(error);
    }
  }

  get authToken(): string {
    // return 'Bearer ' + this._authService.token;
    return 'Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.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.yFE5Yskt2aIIt2lS-cWBH4Zi0PNKXo74dNKgzmPFZQw'
  }

  private _getConfig() {
    let origin = '';
    const url = origin + 'assets/config/config.json';
    return this.httpClient.get(url).subscribe((res) => {
      this._refreshVar(res);
    });
  }

  private _refreshVar(data: any) {
    this.baseURL = data.baseURL;
    this.fileUploadURL = data.fileUploadURL;
    this.keycloakURL = data.KEYCLOAK_URL;
    this.realm = data.KEYCLOAK_REALM;
    this.client = data.KEYCLOAK_CLIENT_ID;
    this.restURL = data.baseURL;

    if (data.idleTimeoutInMin)
      this.idleTimeout = parseInt(data.idleTimeoutInMin) * 60;
    else this.idleTimeout = this.defaultIdleTimeout * 60;

    if (data.idleTimeoutPromptB4Sec)
      this.promptIdleTimeoutB4 = parseInt(data.idleTimeoutPromptB4Sec);
    else this.promptIdleTimeoutB4 = 60;

    this._clearTimer();
  }

  private _clearTimer() {
    this.isPromptTimerAlert = false;
    if (this.idleTimer) clearInterval(this.idleTimer);
  }
}
